import { ChangeDetectionStrategy, Component, InputSignal, input, output, OutputEmitterRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SafeResourceUrl } from '@angular/platform-browser';

import {
  TiimeInputContainerModule,
  TiimeOptionModule,
  TiimeOptionSelectionChange,
  TiimeProgressSpinnerModule,
  TiimeSelectModule
} from 'tiime-material';

import { SelectBase } from '@bases/selector/select.base';
import { Brand } from '@models/brand';
import { ImagePreviewComponent } from '@shared-components/image-preview/image-preview.component';
import { SortByKeyPipe } from '@shared-pipes/sort-by-key/sort-by-key.pipe';

@Component({
  selector: 'app-contract-brand-select',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeInputContainerModule,
    TiimeSelectModule,
    TiimeOptionModule,
    SortByKeyPipe,
    ImagePreviewComponent,
    TiimeProgressSpinnerModule
  ],
  templateUrl: './contract-brand-select.component.html',
  styleUrl: './contract-brand-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractBrandSelectComponent extends SelectBase<Brand> {
  readonly label: InputSignal<string> = input<string>('Marque');
  readonly businessUnitBrand: InputSignal<Brand> = input.required<Brand>();
  readonly logoUrl: InputSignal<SafeResourceUrl> = input<SafeResourceUrl>();
  readonly logoLoading: InputSignal<boolean> = input<boolean>();

  readonly brandChange: OutputEmitterRef<Brand> = output<Brand>();

  emitBrandChange(event: TiimeOptionSelectionChange, brand: Brand): void {
    if (!event.isUserInput) {
      return;
    }

    this.brandChange.emit(brand);
  }
}
